export default function HomeLoading() {
  return (
    <div className="animate-pulse">
      <HeaderSkeleton />

      <HeroSkeleton />

      <div className="container max-w-3xl mx-auto px-4 sm:px-6 md:px-10 space-y-12 -translate-y-24">
        <SectionSkeleton />
        <SliderSkeleton />
        <SectionSkeleton />
        <SliderSkeleton />
        <BannerSkeleton />
        <SectionSkeleton />
        <SliderSkeleton />
      </div>

      <FooterSkeleton />
    </div>
  );
}

export function HeaderSkeleton() {
  return (
    <div className="fixed top-0 inset-x-0 h-[75px] bg-white/5 backdrop-blur-md z-50">
      <div className="container max-w-3xl mx-auto px-4 sm:px-6 md:px-10 h-full flex items-center justify-between">
        <div className="h-6 w-28 sm:w-32 bg-white/10 rounded" />
        <div className="flex gap-2 sm:gap-4">
          <div className="h-8 w-8 bg-white/10 rounded-full" />
          <div className="h-10 w-20 sm:w-24 bg-white/10 rounded-lg" />
          <div className="h-10 w-24 sm:w-28 bg-white/10 rounded-lg" />
        </div>
      </div>
    </div>
  );
}

export function HeroSkeleton() {
  return (
    <div className="h-[60vh] sm:h-[70vh] md:h-screen w-full bg-white/5 relative">
      <div className="absolute bottom-24 left-0 right-0 container max-w-3xl mx-auto px-4 sm:px-6 md:px-10 space-y-4">
        <div className="h-10 w-60 sm:w-80 md:w-96 bg-white/10 rounded" />
        <div className="h-4 w-40 sm:w-56 md:w-64 bg-white/10 rounded" />
        <div className="flex gap-2 sm:gap-4">
          <div className="h-12 w-32 sm:w-36 md:w-40 bg-white/10 rounded-lg" />
          <div className="h-12 w-32 sm:w-36 md:w-40 bg-white/10 rounded-lg" />
        </div>
      </div>
    </div>
  );
}

export function SectionSkeleton() {
  return (
    <div className="flex justify-between items-center">
      <div className="h-6 w-32 sm:w-40 bg-white/10 rounded" />
      <div className="h-4 w-16 sm:w-20 bg-white/10 rounded" />
    </div>
  );
}

export function SliderSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div className="flex gap-4 overflow-x-auto pb-2">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex-shrink-0 w-[140px] sm:w-[180px] md:w-[195px] h-[220px] sm:h-[300px] md:h-[320px] bg-white/10 rounded-md"
        />
      ))}
    </div>
  );
}

export function GridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-3">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="h-[120px] sm:h-[160px] md:h-[184px] bg-white/10 rounded-md"
        />
      ))}
    </div>
  );
}

export function BannerSkeleton() {
  return (
    <div className="w-full aspect-[21/9] bg-white/10 rounded-xl" />
  );
}

export function FooterSkeleton() {
  return (
    <div className="mt-20 h-40 bg-white/5" />
  );
}